import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../../utils/http";

const initialState = {
  isLoading: false,
  books: {},
};

export const getPreviewBooks = createAsyncThunk(
  "application/getSidekickProducts",
  async (_payload, thunkAPI) => {
    try {
      const response = await http.get(
        `${process.env.REACT_APP_API_SIDEKICK_BASE_URL}/get-need-approval-books`
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateBookApproval = createAsyncThunk(
  "application/updateCharacter",
  async (payload, thunkAPI) => {
    try {
      const response = await http.patch(
        `${process.env.REACT_APP_API_SIDEKICK_BASE_URL}/books-approval/${payload.slug}`,
        payload
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const previewBooksSlice = createSlice({
  name: "sidekick-products",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getPreviewBooks.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPreviewBooks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.books = action.payload;
      })
      .addCase(getPreviewBooks.rejected, (state) => {
        state.isLoading = false;
        state.books = [];
      })
      .addCase(updateBookApproval.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateBookApproval.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateBookApproval.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default previewBooksSlice.reducer;
